import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Tiles } from 'wsm-tiles';
import { usePaginationContext } from '../../contexts/PaginationContext';
import Pagination from '../pagination/Pagination';
import useTileHover from '../../hooks/useTileHover';

const TilesSection = ({ tileData, onTileHover }) => {
	const { currentPage } = usePaginationContext();
	const containerRef = useRef(null);

	const { handleMouseOver, handleMouseLeave, handleFocus, handleBlur } =
		useTileHover({
			containerRef,
			tileData,
			onTileHover
		});

	return (
		<>
			<div
				ref={containerRef}
				className="w-100 mx-auto p-0"
				style={{ maxWidth: '1200px' }}
				role="main"
				aria-label={`Location results, page ${currentPage || 1}`}
				onMouseOver={handleMouseOver}
				onMouseLeave={handleMouseLeave}
				onFocus={handleFocus}
				onBlur={handleBlur}
			>
				<Tiles
					type="location"
					data={tileData}
					layout="grid"
					className="justify-content-center"
				/>
			</div>

			<div
				className="w-100 py-4 d-flex justify-content-center align-items-center"
				role="navigation"
				aria-label="Pagination Navigation"
			>
				<Pagination />
			</div>
		</>
	);
};

TilesSection.propTypes = {
	tileData: PropTypes.arrayOf(
		PropTypes.shape({
			location: PropTypes.shape({
				name: PropTypes.string,
				distance: PropTypes.string,
				isOpen: PropTypes.bool,
				openCloseText: PropTypes.string,
				href: PropTypes.string
			}),
			displayType: PropTypes.string
		})
	).isRequired,
	onTileHover: PropTypes.func.isRequired
};

export default TilesSection;
